import { Redirect, RouteProps } from "react-router";
import Dashboard from "../pages/JourneesDepistage/dashboard";
import Planning from "../pages/JourneesDepistage/planning";
import Profile from "../pages/Profile";

const medecinPlanificateurRoutes: RouteProps[] = [
  {
    path: "/journeesdepistage/dashboard",
    component: Dashboard,
    exact: true,
  },
  {
    path: "/journeesdepistage/planning",
    component: Planning,
    exact: true,
  },
  {
    path: "/profile",
    component: Profile,
    exact: true,
  },
  {
    path: "/journeesdepistage",
    exact: true,
    render: () => <Redirect to="/journeesdepistage/planning" />,
  },
];

export default medecinPlanificateurRoutes;